(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.CustomConfiguratorPricing = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function parseFraction(value) {
    var text = String(value || '0').trim();
    if (/^-?\d+(?:\.\d+)?$/.test(text)) return Number(text);
    var match = text.match(/^(-?\d+)\s*\/\s*(\d+)$/);
    if (!match || Number(match[2]) === 0) return 0;
    return Number(match[1]) / Number(match[2]);
  }

  function parseQuery(search, decodeValues) {
    var parameters = {};
    var query = String(search === undefined ? (typeof location !== 'undefined' ? location.search : '') : search)
      .replace(/^\?/, '');
    if (!query) return parameters;
    query.split('&').forEach(function (part) {
      if (!part) return;
      var separator = part.indexOf('=');
      var rawKey = separator === -1 ? part : part.slice(0, separator);
      var rawValue = separator === -1 ? '' : part.slice(separator + 1);
      try {
        parameters[decodeURIComponent(rawKey.replace(/\+/g, ' '))] = decodeValues === false
          ? rawValue
          : decodeURIComponent(rawValue.replace(/\+/g, ' '));
      } catch (error) {
        parameters[rawKey] = rawValue;
      }
    });
    return parameters;
  }

  function numberFormat(number, decimals, decPoint, thousandsSep) {
    var sanitized = String(number).replace(/[^0-9+\-Ee.]/g, '');
    var numeric = Number.isFinite(Number(sanitized)) ? Number(sanitized) : 0;
    var precision = Number.isFinite(Number(decimals)) ? Math.abs(Number(decimals)) : 2;
    var decimal = decPoint === undefined ? '.' : decPoint;
    var separator = thousandsSep === undefined ? ',' : thousandsSep;
    var factor = Math.pow(10, precision);
    var parts = String(precision ? Math.round(numeric * factor) / factor : Math.round(numeric)).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    if ((parts[1] || '').length < precision) {
      parts[1] = parts[1] || '';
      parts[1] += new Array(precision - parts[1].length + 1).join('0');
    }
    return parts.join(decimal);
  }

  function dateOnly(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? match[1] + '-' + match[2] + '-' + match[3] : null;
  }

  function saleAdjustedPrice(rawPrice, percent, start, end, today) {
    rawPrice = Number(rawPrice);
    percent = Number(percent);
    start = dateOnly(start);
    end = dateOnly(end);
    today = dateOnly(today);
    if (!Number.isFinite(rawPrice) || !Number.isFinite(percent) || percent < 0 || percent > 100 ||
      !start || !end || !today || start > end || today < start || today > end) {
      return rawPrice;
    }
    return rawPrice - (rawPrice * percent / 100);
  }

  function blindTotals(input) {
    var productRaw = Number(input.productRaw || 0) + Number(input.valanceRaw || 0) + Number(input.bottomRailRaw || 0);
    var productSale = saleAdjustedPrice(productRaw, input.productSalePercent, input.productSaleStart, input.productSaleEnd, input.today);
    var liftRaw = Number(input.liftRaw || 0);
    var liftSale = saleAdjustedPrice(liftRaw, input.liftSalePercent, input.liftSaleStart, input.liftSaleEnd, input.today);
    var addons = Number(input.addons || 0);
    var warranty = Number(input.warranty || 0);
    var quantity = Math.max(1, Number(input.quantity || 1));
    return {
      displayed: (productSale + liftSale + addons + warranty) * quantity,
      compareAt: (productRaw + liftRaw + addons + warranty) * quantity,
    };
  }

  function blindCommittedTotals(input) {
    var productDisplayed = Number(input.productDisplayed || 0);
    var productRaw = Number(input.productRaw || 0);
    var liftDisplayed = Number(input.liftDisplayed || 0);
    var liftRaw = Number(input.liftRaw || 0);
    var addons = Number(input.addons || 0);
    var warranty = Number(input.warranty || 0);
    var quantity = Math.max(1, Number(input.quantity || 1));
    var liftCompareAt = liftDisplayed !== liftRaw ? liftRaw : liftDisplayed;
    return {
      displayed: (productDisplayed + liftDisplayed + addons + warranty) * quantity,
      compareAt: (productRaw + liftCompareAt + addons + warranty) * quantity,
    };
  }

  function draperyTotals(input) {
    var fabric = Number(input.fabricPrice || 0) * Number(input.fabricMeters || 0);
    var labor = Number(input.labor || 0);
    var lining = Number(input.liningPrice || 0) * Number(input.liningMeters || 0);
    var hardware = Number(input.hardware || 0);
    var snaps = Number(input.snaps || 0) * Number(input.snapPrice || 3.99);
    var quantity = Math.max(1, Number(input.quantity || 1));
    var regular = quantity * (fabric + labor + lining + hardware) + snaps;
    var discountedFabric = fabric * (1 - Number(input.fabricDiscount || 0) / 100);
    var discountedLabor = labor * (1 - Number(input.laborDiscount || 0) / 100);
    var discounted = quantity * (discountedFabric + discountedLabor + lining + hardware) + snaps;
    return {
      regular: regular,
      displayed: Number(input.fabricDiscount || 0) > 0 || Number(input.laborDiscount || 0) > 0 ? discounted : regular,
    };
  }

  return Object.freeze({
    parseFraction: parseFraction,
    parseQuery: parseQuery,
    numberFormat: numberFormat,
    saleAdjustedPrice: saleAdjustedPrice,
    blindTotals: blindTotals,
    blindCommittedTotals: blindCommittedTotals,
    draperyTotals: draperyTotals,
  });
}));
